<template>
    <div class="w-full">
        <base-button-ghost
            @click="handleClick"
            :variant="buttonVariant"
            :class="[
                'h-[41px] w-full text-[16px]',
                { 'opacity-50 hover:opacity-50': isVisuallyDisabled },
            ]"
        >
            {{ buttonCopy }}
        </base-button-ghost>

        <auto-modal
            v-if="addToCartError"
            :text="$t('UNEXPECTED_ERROR')"
            @close="closeAddToCartError"
        />
    </div>
</template>

<script>
    import allStores from '../../stores/all';

    import AutoModal from '../AutoModal.vue';
    import BaseButtonGhost from './BaseButtonGhost.vue';

    export default {
        mixins: [allStores],

        components: {
            AutoModal,
            BaseButtonGhost,
        },

        props: {
            isDisabled: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                showModal: false,
                showModalUpdated: false,
                addToCartError: false,
            };
        },

        computed: {
            currentGroup() {
                return this.customizerStore.currentGroup;
            },

            saveButtonMode() {
                return this.customizerStore.options.saveButtonMode;
            },

            visibleGroups() {
                return this.customizerStore.visibleGroups;
            },

            allGroupsSeen() {
                return this.customizerStore.groupsSeen.length === this.visibleGroups.length;
            },

            isButtonDisabled() {
                return this.isDisabled;
            },

            isVisuallyDisabled() {
                return this.saveButtonMode === 'single-incomplete'
                    && !this.enableAddToCart
                    && !this.isButtonDisabled;
            },

            viewController() {
                return this.customizerStore.viewController;
            },

            buttonCopy() {
                if (this.customizerStore.options.saveButtonTitle) {
                    return `${this.$t(this.customizerStore.options.saveButtonTitle)}`;
                }

                return `${this.$t('SAVE_AND_EXIT')}`;
            },

            buttonVariant() {
                // const primaryStyle = this.selectionWasMade && this.hasBeenSeen ? 'primary' : 'primaryDisabled';

                // return this.enableAddToCart || (this.isEditingFromCart && this.selectionWasMade) ? 'red' : primaryStyle;
                return 'primary';
            },

            selectionWasMade() {
                // TODO: REVIEW!
                return false;
            },

            enableAddToCart() {
                if (this.inErrorState) {
                    return false;
                }

                return this.totalSelectionsMade === this.totalSteps;
            },

            isEditingFromCart() {
                // TODO: REVIEW!
                return false;
            },

            inErrorState() {
                return false;
            },

            isMobile() {
                return this.appStore.isMobile;
            },

            totalSteps() {
                return this.customizerStore.totalSteps;
            },

            totalSelectionsMade() {
                return this.customizerStore.totalSelectionsMade;
            },
        },

        methods: {
            addToCart() {
                this.customizerStore.addCurrentSelectionsToCart().catch(() => {
                    this.appStore.setIsBusy(false);
                    this.addToCartError = true;
                });
            },

            handleClick() {
                if (this.customizerStore.options.saveButtonMode === 'single') {
                    if (!this.enableAddToCart) {
                        this.customizerStore.addPanelToErrorState('Main');

                        if (this.isMobile) {
                            this.appStore.setShouldShowViewAll(true);
                        }
                        return;
                    }

                    this.customizerStore.removePanelFromErrorState('Main');
                    this.addToCart();
                } else {
                    this.customizerStore.saveAndExit();
                }
            },

            closeAddToCartError() {
                this.addToCartError = false;
            },
        },
    };
</script>
